import React, { useState } from 'react';
import Box from '@mui/material/Box';

import { useFetchNotesQuery } from '../../api/index';
import { ToolBar } from './LeftToolBar';
import PageLocalHistory from './PageLocalHistory';
import PageTest from '../../home/pageTest';

export function PageLeftPane() {
	const viewStyle = {
		height: `calc(100% - 44px)`,
		overflow: 'auto',
		padding: 2,
		//height: '100%r',
		//backgroundColor: 'purple',
	};

	return (
		<Box sx={{height: '100%'}}>
			<ToolBar />
			<Box sx={{height: 45}}>
			</Box>
			<Box sx={viewStyle}>
				<PageLocalHistory />
				{//*
				<PageTest words={4} para={4} />
			//*/
			}
			</Box>
		</Box>
	)
}

